export default __webpack_public_path__ + "static/media/gallery_05.51b07c32.jpg";